export const url = "https://p-board.herokuapp.com/api";

export const header = {
  "Content-Type": "application/json",
  Authorization: `Bearer ${
    localStorage.getItem("session")
      ? JSON.parse(localStorage.getItem("session")).token
      : null
  }`,
};

